import { createFileRoute } from "@tanstack/react-router";
import FloridaBlueMarketplaceInsurance, {
  config,
} from "@/pages/FloridaBlueMarketplaceInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/florida-blue-marketplace-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Florida Blue Marketplace TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Have a Florida Blue Marketplace plan? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your ACA.",
        },
        {
          property: "og:title",
          content: "Florida Blue Marketplace TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Have a Florida Blue Marketplace plan? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your ACA.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/florida-blue-marketplace-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/florida-blue-marketplace-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <FloridaBlueMarketplaceInsurance />;
}
